/* eslint-disable react-hooks/exhaustive-deps */
import React, { useContext } from "react";
import { Stack, Typography, Button, Input, InputLabel, TextField } from "@mui/material";
import { Upload } from "@mui/icons-material";
import jwtDecode from "jwt-decode";
import { AppContext } from "../../context/AppProvider";
import { Text } from "../../components/Text";

const validateInstallationID = (id) => {
  const isValid = !id || /^[0-9a-f]{8}-[0-9a-f]{4}-[0-5][0-9a-f]{3}-[089ab][0-9a-f]{3}-[0-9a-f]{12}$/i.test(id);

  if (!isValid) {
    throw new Error(`Invalid installation ID`);
  }
}

const validateActivationKey = (key = "") => {
  try {
    key = key
      .replace("-----BEGIN ACTIVATION KEY-----", "")
      .replace("-----END ACTIVATION KEY-----", "")
      .replace(/\n/g, "");

    key && jwtDecode(key);
  } catch (e) {
    throw new Error(`Invalid activation key format`);
  }
}

export const ActivationForm = () => {
  const { activation, license, setInstallationId, setActivationKey, activateLicense } = useContext(AppContext);
  const { activationKey, installationId } = activation;

  const uploadRef = React.createRef();

  const promptUpload = () => {
    uploadRef.current.click();
  }

  const upload = (e) => {
    const reader = new FileReader();

    reader.onload = (event) => {
      setActivationKey(event.target.result);
    }

    reader.readAsText(e, "UTF-8");
  }

  return (
    <Stack direction="column" spacing={5} width="90%">
      <Text
        subtext={<span>The Installation ID is the key generated by the specific server installation. It can be found in <strong>Diagnostics / System Info</strong></span>}
        label={
          <Stack direction="row" spacing={1}>
            <InputLabel sx={{fontWeight: 'bold', color: '#000'}}>Installation ID</InputLabel>
          </Stack>
        }
        value={installationId}
        onValidate={validateInstallationID}
        onChange={setInstallationId}
      />

      <Text
        subtext="The activation key was provided when purchasing your Kasm Workspaces license."
        label={
          <Stack direction="row" spacing={1} alignItems="center" justifyContent="space-between">
            <Stack direction="row" spacing={1}>
              <InputLabel sx={{fontWeight: 'bold', color: '#000'}}>Activation Key</InputLabel>
            </Stack>
            <Stack>
              <Input
                ref={uploadRef}
                accept="*"
                type="file"
                sx={{ display: "none" }}
                onChange={e => upload(e.target.files[0])} />
              <Button
                size="small"
                variant="outlined"
                endIcon={<Upload />}
                onClick={promptUpload}>
                Upload
              </Button>
            </Stack>
          </Stack>
        }
        value={activationKey}
        onValidate={validateActivationKey}
        onChange={setActivationKey}
        inputProps={{
          multiline: true,
          rows: 10
        }}
      />

      {license.customerType === "partner" && (
        <Stack direction="column" spacing={2}>
          <Typography variant="title">Advanced</Typography>

          <Stack direction="row" spacing={2} justifyContent="space-between">
            <TextField label="Seats" variant="outlined" value={license.seats} disabled></TextField>
            <TextField label="Issued To" variant="outlined" value={license.customer} disabled></TextField>
          </Stack>
        </Stack>
      )}

      <Stack direction="row" spacing={2} justifyContent="center">
        <Button
          variant="contained"
          size="large"
          disabled={!license}
          onClick={activateLicense}
        >
          Submit
        </Button>
      </Stack>
    </Stack >
  );
}